import React, { useState, useEffect } from 'react';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';

function LiveContacts({ contacts }) {

  const storedContacts = JSON.parse(contacts);

  // Format phone number by removing spaces and dashes, and prepare for links
  const formatPhoneNumber = (phoneNumber) => {
    // Remove spaces and dashes
    const cleanedNumber = phoneNumber.replace(/[\s-]/g, '');
    
    if (cleanedNumber.startsWith('+60')) {
      // If starts with +60, use the number without the +
      return cleanedNumber.substring(1); // Remove the + sign
    } else if (cleanedNumber.startsWith('0')) {
      // If starts with 0, replace it with 60
      return '60' + cleanedNumber.substring(1);
    }
    // Fallback: just return cleaned number
    return cleanedNumber;
  };
  
  return (
    <div className="relative">
      {storedContacts.length === 0 ? (
        <div className='border p-2 my-2 rounded flex items-center justify-between'>
          <p>Tiada nombor telefon untuk dihubungi</p>
        </div>
      ) : (
        storedContacts.map((contact, index) => (
          <div key={index} className="border p-2 my-2 rounded flex items-center justify-between">
            <p>{contact.name}</p>
            <div className="flex space-x-2">
              {contact.contactMethod === 'whatsapp' && (
                <a
                  className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 text-neutral-50 text-2xl"
                  href={`https://wa.me/${formatPhoneNumber(contact.phoneNumber)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp />
                </a>
              )}
              {contact.contactMethod === 'phonecall' && (
                <a
                  className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-500 text-neutral-50 text-2xl"
                  href={`tel://+${formatPhoneNumber(contact.phoneNumber)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaPhone />
                </a>
              )}
              {contact.contactMethod === 'both' && (
                <>
                  <a
                    className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-500 text-neutral-50 text-2xl"
                    href={`tel://+${formatPhoneNumber(contact.phoneNumber)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaPhone />
                  </a>
                  <a
                    className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 text-neutral-50 text-2xl"
                    href={`https://wa.me/${formatPhoneNumber(contact.phoneNumber)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp />
                  </a>
                </>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default LiveContacts;
